import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";






















import LocationFormSelect from "../../../../location/components/location/LocationForm/LocationFormSelect";

import { PrimaryProvider } from "../../../../timber/types/models/Provider";

import ProviderFormSelect from "../../../../timber/components/provider/ProviderForm/ProviderFormSelect";



import ContractorFormSelect from "../../../../timber/components/contractor/ContractorForm/ContractorFormSelect";

import { PrimaryForestOwner } from "../../../../timber/types/models/ForestOwner";

import ForestOwnerFormSelect from "../../../../timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect";









import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";




























export const initialFormStateFn = () => { return {
    
        
        name: "",
        
    
        
        state: CuttingState.Upcoming,
        
    
        
        startAt: formatDateTimeParam(new Date()),
        
    
        
        endAt: formatDateTimeParam(new Date()),
        
    
        
        workOrder: "",
        
    
        
        locationId: null,
        
    
        
        providerId: null,
        
    
        
        contractorId: null,
        
    
        
        forestOwnerId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.providerId = PrimaryProvider.fromQuery(location.state?.providerId) || null;
    initialFormState.forestOwnerId = PrimaryForestOwner.fromQuery(location.state?.forestOwnerId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        state:
        string()
        .trim()
        .min(1, msg`State is required`),
    
    
        startAt:
        string()
        .trim()
        .min(1, msg`Start At is required`),
    
    
        endAt:
        string()
        .trim()
        .min(1, msg`End At is required`),
    
    
        workOrder:
        string()
        .trim()
        .nullish(),
    
    
        locationId:
        string()
                .nanoid(msg`Location is required`)
                .min(1, msg`Location is required`),
    
    
        providerId:
        string()
                .nanoid(msg`Provider is required`)
                .min(1, msg`Provider is required`),
    
    
        contractorId:
        string()
                .nanoid(msg`Contractor is required`)
                .min(1, msg`Contractor is required`),
    
    
        forestOwnerId:
        string()
                .nanoid(msg`Forest Owner is required`)
                .nullish(),
    
};

export const formSchema = object(formObject);

const CuttingAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
           
           
   
    <crudgen.FormSelect
        required
        name={ prefix + 'state' }
        aria-label="state"
        label={t`State`}
        options={ CuttingStatePairs }
        optionLabelMap={ toStringCuttingState }
    />
   
   
           
           
   
        
           <crudgen.FormDateTime
                required
                name={ prefix + 'startAt' }
                aria-label="startAt"
                label={t`Start At`}
           />
       
   
   
           
           
   
        
           <crudgen.FormDateTime
                required
                name={ prefix + 'endAt' }
                aria-label="endAt"
                label={t`End At`}
           />
       
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'workOrder' }
       aria-label="workOrder"
       data-testid="workOrder"
       label={t`Work Order`}
       
       type='text'
       
   />
   
   
           
           
   
    
    <LocationFormSelect
        type="dynamicSelect"
        name="locationId"
        label={t`Location`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <ProviderFormSelect
        type="dynamicSelect"
        name="providerId"
        label={t`Provider`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <ContractorFormSelect
        type="dynamicSelect"
        name="contractorId"
        label={t`Contractor`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <ForestOwnerFormSelect
        type="dynamicSelect"
        name="forestOwnerId"
        label={t`Forest Owner`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
        </Container>
    )
}

export default CuttingAddForm;
